
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.275,"time":16500,"words":55}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`MARZAGALLI, Silvia, ASSELIN, Cécile, BOUJU, Alain, CHARLES, Loïc, DAUDIN, Guillaume, GEOFFROY, Géraldine, GIRARD, Paul, GOURLET, Pauline, MAZOYER, Béatrice, de MOURAT, Robin, OOGHE-TABANOU, Benjamin, PLIQUE, Guillaume, PLUMEJEAUD, Christine, POURCHASSE, Pierrick, SAUZEAU, Thierry, THÉRO, Héloïse et ZOFFOLI, Maxime, 2021. Commerce multi-échelles autour du port de La Rochelle au XVIIIe siècle. `}{`[en ligne]`}{`. Octobre 2021. Disponible à l’adresse : `}<a parentName="p" {...{
        "href": "https://medialab.github.io/portic-storymaps-2021"
      }}>{`https://medialab.github.io/portic-storymaps-2021`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {}

